module.exports = __webpack_public_path__ + "static/img/1.abfa3fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user/1.png
// module id = cUC+
// module chunks = 0